import React from 'react';
import { useSelector } from 'react-redux';
import imgLoader from '../../../assets/img/loading.gif';

import { WrapperLoader } from './styles';

const Loader = () => {
  const storeDataVerificacion = useSelector((store) => store.ui.loaders.isLoaderVerificar);
  const storeDataOferta = useSelector((store) => store.ui.loaders.isLoaderOferta);
  return (
    <WrapperLoader>
      {storeDataVerificacion || storeDataOferta ? (
        <div className="loader-contenedor">
          <img src={imgLoader} alt="loader-coopeuch" />
        </div>
      ) : ('')}
    </WrapperLoader>
  )
}

export default Loader;